import { ReactElement, useEffect, useState } from 'react';

import { useVendasResumo } from '../../../../../../services/hooks/useVendasResumo';
import { CardIcon, Container, Grid } from './styles';

interface IProps {
  title: string;
  icon: ReactElement;
  params: {
    docto: string;
    dtInicial: string;
    dtFinal: string;
    pagina: number;
    limite: number;
    bandeira: string;
  };
}

export const Card = ({ title, icon, params }: IProps) => {
  const { data, isLoading, isFetching, error, refetch } = useVendasResumo(
    params,
    'card'
  );

  const sumTotal = data?.reduce((acc, resumo) => acc + resumo.vlTransacao, 0);

  const tiposProd = [...new Set(data?.flatMap((resumo) => resumo.tipoProd))];

  const resumos = tiposProd?.map((tipoProd) =>
    data?.filter((venda) => venda.tipoProd === tipoProd)
  );

  const vendasResumoData = resumos?.map((venda) =>
    venda?.reduce(
      (acc, index) => ({
        name: index.tipoProd,
        quantity: acc.quantity + index.qtdTransacao || 0,
        value: acc.value + index.vlTransacao || 0,
      }),
      { name: '', quantity: 0, value: 0 }
    )
  );

  return (
    <Container>
      <CardIcon>{icon}</CardIcon>
      {title}
      <p className="cardValue">
        {sumTotal?.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
        })}
      </p>

      <div className="gridContainer">
        {isLoading || isFetching ? (
          <Grid>
            <p>Carregando...</p>
          </Grid>
        ) : error ? (
          <Grid>
            <p>Falha ao carregar dados.</p>
          </Grid>
        ) : (
          vendasResumoData?.map((info) => (
            <Grid key={info?.name}>
              {info?.name === 'CP' && <p>Crédito Parcelado</p>}
              {info?.name === 'CV' && <p>Crédito à Vista</p>}
              {info?.name === 'DB' && <p>Débito</p>}
              {info?.name === 'PX' && <p>Pix</p>}
              <p>{info?.quantity}</p>
              <p>
                {info?.value?.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                })}
              </p>
            </Grid>
          ))
        )}
      </div>
    </Container>
  );
};
